import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import marked from "marked";

import MarkdownRenderer from '../../components/MarkdownRenderer';

class Containers extends Component {

    constructor(props) {
        super(props);

        this.state = {
            spacing: '',
            cards: ''
        }

        this.props.includeNav();
    }

    componentWillMount() {
        const cardsPath = require("./cards.md");
        const spacingPath = require("./spacing.md");
        
        fetch(cardsPath)
            .then(response => {
                return response.text()
            })
            .then(text => {
                this.setState({
                    cards: marked(text)
                })
            })

        fetch(spacingPath)
            .then(response => {
                return response.text()
            })
            .then(text => {
                this.setState({
                    spacing: marked(text)
                })
            })
    }

    render() {

        return (
            <DocumentTitle
                title={'BCS Documentation - Containers'}>
                <section className="page" data-component="containers">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Containers</h1>
                            <p>Container styling and spacing can be applied via various utility classes.</p>
                        </div>
                    </div>
                    <div className="row card-group">
                        <div className="col-xs-12">
                            <MarkdownRenderer text={this.state.spacing}/>
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.cards}/>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="card-with-title notification-read">
                                <div className="card-title">
                                    <h4>Wed</h4>
                                    <p className="card-title-month">September</p>
                                    <p className="card-title-date">20</p>
                                    <p className="card-title-time">5:30p - 8:30p</p>
                                </div>
                                <div className="card-content">
                                    Lorem Khaled Ipsum is a major key to success. Give thanks to the most high. Let me be clear, you have to make it through the jungle to make it to paradise, that’s the key, Lion!
                                </div>
                                <div className="card-footer">
                                    <i className="fa fa-comments text-purple margin-r-2" aria-hidden="true"></i>footer content
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="card-with-title">
                                <div className="card-title">
                                    <h4>Sat</h4>
                                    <p className="card-title-month">September</p>
                                    <p className="card-title-date">16</p>
                                    <p className="card-title-time">8:30a - 8:30p</p>
                                </div>
                                <div className="card-content">
                                    Another One
                                </div>
                                <div className="card-footer">
                                    <i className="fa fa-comments text-purple margin-r-2" aria-hidden="true"></i>footer content
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row flex-column">
                        <div className="col-xs-12 col-md-4 first-xs last-md">
                            <div className="card-with-title card-skinny">
                            <div className="card-title">
                                <h4>Wed</h4>
                                <p className="card-title-month">October</p>
                                <p className="card-title-date">20</p>
                                <p className="card-title-time">5:30p - 8:30p</p>
                            </div>
                            <div className="card-content">
                                <h3>6.3 - Intro to Professional Grade JavaScript</h3>
                                <p>lorem ipsum dolor set amet</p>
                            </div>
                            <div className="card-footer">
                                <ul className="card-footer-list">
                                <li><a href="/"><i className="fa fa-map-marker"></i> Campus</a></li>
                                <li><a href="/"><i className="fa fa-copy"></i> Session Details</a></li>
                                <li><a href="/"><i className="fa fa-sign-out-alt"></i> Request Absence</a></li>
                                <li><a href="/"><i className="fa fa-check-square"></i> Check In To Class</a></li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="card-with-title card-wide">
                                <div className="card-title">
                                    <h4>Wed</h4>
                                    <p className="card-title-month">September</p>
                                    <p className="card-title-date">20</p>
                                    <p className="card-title-time">5:30p - 8:30p</p>
                                </div>
                                <div className="card-content">
                                    I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing.
                                </div>
                                <div className="card-footer">
                                    <ul className="card-footer-list">
                                    <li><a href="/coursework/12345"><i className="fa fa-cloud-download-alt"></i> Instructions</a></li>
                                    <li><a href="/coursework/00010/submit"><i className="fa fa-upload"></i> Submit</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className="context-error">
                                <div className="card-with-title card-wide">
                                    <div className="card-title">
                                        <h4>Wed</h4>
                                        <p className="card-title-month">September</p>
                                        <p className="card-title-date">20</p>
                                        <p className="card-title-time">5:30p - 8:30p</p>
                                    </div>
                                    <div className="card-content">
                                        I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing.
                                    </div>
                                    <div className="card-footer">
                                        <ul className="card-footer-list">
                                            <li><a href="/coursework/12345"><i className="fa fa-cloud-download-alt"></i> Instructions</a></li>
                                            <li><a href="/coursework/00010/submit"><i className="fa fa-upload"></i> Submit</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Containers;



// WEBPACK FOOTER //
// ./src/pages/Containers/index.js